import Axios from 'axios';
import Config from 'core/config';

export default Axios.create({
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
  baseURL: Config.axios.base,
});



// WEBPACK FOOTER //
// ./src/core/axios.js